import ImageXComponent from '../components/ImageX/viewer/ImageX';
import ImageXController from '../components/ImageX/viewer/ImageX.controller';


const ImageX = {
  component: ImageXComponent,
  controller: ImageXController
};


export const components = {
  ['ImageX']: ImageX
};

